/** @file LoginScreen: the owner's password, sent to `POST /auth/login`; the browser keeps the session cookie. */
import { useState } from 'react';
import type { ReactElement, SyntheticEvent } from 'react';
import { useEditorStore } from '../state/useEditorStore';
import { asPose3DError } from '../store/asPose3DError';
import type { EditorApi } from '../store/editorApi';
import { errorText } from '../store/errorText';
import { Button } from '../ui-kit/Button';
import { Field } from '../ui-kit/Field';

/** On success the session becomes signed-in and the shell takes over; a failure is shown under the field. */
export function LoginScreen({ api }: { api: EditorApi }): ReactElement {
  const store = useEditorStore();
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const submit = (e: SyntheticEvent): void => {
    e.preventDefault();
    setBusy(true);
    setError(null);
    api.login(password).then(({ me }) => {
      store.setState((s) => ({ session: { ...s.session, owner: me.owner, status: 'signed-in' } }));
    }, (err: unknown) => {
      setBusy(false);
      setError(errorText(asPose3DError(err)));
    });
  };
  return (
    <div className="p3-login">
      <form onSubmit={submit} aria-label="Sign in">
        <span className="p3-brand">POSE3D</span>
        <span className="p3-muted p3-mono">{api.url}</span>
        <Field label="Password">
          <input className="p3-input" type="password" autoComplete="current-password" value={password}
            onChange={(e) => { setPassword(e.target.value); }} />
        </Field>
        {error === null ? null : <span className="p3-error" role="alert">{error}</span>}
        <Button type="submit" variant="primary" disabled={busy || password === ''}>Sign in</Button>
      </form>
    </div>
  );
}
